/**
 * An unrouted path.
 *
 * Says which path, because the usual cause is a stale bookmark or a link from
 * elsewhere in the product — and knowing what was asked for is how somebody
 * works out which. It also names the likeliest reason: a screen belonging to a
 * service this installation does not have.
 */

import { Link, useLocation } from 'react-router-dom';
import { Compass } from 'lucide-react';
import { PageHeader, buttonClass } from '@connect/web-shared';

export function NotFoundPage() {
  const location = useLocation();

  return (
    <div className="space-y-4">
      <PageHeader title="There is nothing here" />
      <div className="flex flex-col items-start gap-3 rounded-card border border-line bg-surface p-5">
        <span className="flex size-10 items-center justify-center rounded-full bg-surface-2 text-faint">
          <Compass className="size-5" />
        </span>
        <div className="space-y-1">
          <p className="text-sm text-body">
            No page is routed at <span className="font-mono text-xs">{location.pathname}</span>.
          </p>
          <p className="text-sm text-muted">
            If you followed a link from inside Connect, the screen may belong to a service this
            installation does not have enabled.
          </p>
        </div>
        <Link to="/" className={buttonClass({ variant: 'secondary', size: 'sm' })}>
          Back to the overview
        </Link>
      </div>
    </div>
  );
}
